import { HOME_BODY_COLOR } from "styles/oneOffColor";

const styles = {
  root: {
    backgroundColor: HOME_BODY_COLOR,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    position: "fixed",
    overflowY: "auto",
    px: { xs: 0, sm: 3, md: 5, lg: 20 },
    py: { xs: 0, sm: 2, md: 5 },
    opacity: 1,
    backgroundSize: "22px 22px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  formContainer: {
    borderRadius: { xs: 0, sm: 4 },
    backgroundColor: HOME_BODY_COLOR,
    maxWidth: { lg: "1024px" },
    p: { xs: 3, sm: 5, md: 8 },
  },
  textField: {
    backgroundColor: "white",
    "& .MuiInputBase-root": { backgroundColor: "white" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  },
  helperText: {},
};

export default styles;
